export const ICON_PREVIEW_SIZE = 98;

export const ICON_COLOR_FILTER_TAB_INDEX = {
  All: 0,
  Color: 1,
  Mono: 2,
};

export const RECOMMENDED_ICON_PACK_ID = -1;
